// global computed baseUrl (this.baseUrl)
// global computed deviceToken (this.deviceToken)
// global computed session (this.session)
export default {
  computed: {
    baseUrl () {
      return process.env.VUE_APP_API_URL + ''
    },
    deviceToken () {
      return this.$store.getters.deviceToken
    },
    session () {
      return this.$store.getters.session
    }
  }
}
